import { createWidget } from '@funtech-int/rival';

import { SuggestProps } from './components/Suggest/Suggest';

export const suggestWidget = createWidget<unknown, SuggestProps>();
